export default __webpack_public_path__ + "static/media/logo_si.47b2058d.png";